import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const CrowdingResolutionInput = ({ register, error, helperText }) => {
  const items = [
    "Proclination permitted",
    "Expansion permitted",
    "IPR permitted",
    "Distalization permitted",
  ];

  return (
    <React.Fragment>
      <Grid item xs={3} sx={{marginTop: 1}}>
        <StyledLabel error={error} id="crowding-resolution-label">
          Crowding Resolution
        </StyledLabel>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <FormControl>
          <RadioGroup
            aria-labelledby="crowding-resolution-label"
            name="crowdingResolution"
          >
            {items.map((item) => (
              <FormControlLabel key={item} value={item} control={<Checkbox {...register("crowdingResolution")}/>} label={item} />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
    </React.Fragment>
  );
};

export default CrowdingResolutionInput;
